import React, { useRef, useEffect, useState } from "react";
import DotCommand from "../Commands/DotCommand/DotCommand";
import DelCommand from "../Commands/DelCommand/DelCommand";
import AddIcon from "../Commands/AddIcon/AddIcon";
import SettingsIcon from "../Commands/SettingsIcon/SettingsIcon";
import DeleteIcon from "../Commands/DeleteIcon/DeleteIcon";
import "./MenuDots.css";

//export default function DropDownListNew(props) {
export default function MenuDots(props) {
  const [isExpanded, setIsExpanded] = useState(false);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */

      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          isExpanded &&
            event.target.className != "limenu" &&
            setIsExpanded(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isExpanded]);
  }

  const handleClickItem = (item) => {
    props.onMenuItemClick(item);
    setIsExpanded(false);
  };

  const handleCommandClick = () => {
    if (props.currentData.length > 1)
      props.isMenuVisible && setIsExpanded(!isExpanded);
    else props.onMenuItemClick(props.currentData[0]);
  };

  const getIcon = (item) => {
    switch (item.action.icon) {
      case "Add":
        return <AddIcon />;
      case "Open":
        return <SettingsIcon />;
      case "Delete":
        return <DeleteIcon />;
    }
  };

  const wrapperRef = useRef(null);
  const menuLenght = props.currentData.length;
  useOutsideAlerter(wrapperRef);
  return (
    <div>
      <div
        className="commandRow"
        ref={wrapperRef}
        onClick={() => handleCommandClick()}
      >
        {menuLenght == 1 ? (
          <DelCommand
            isShow={isExpanded || props.isMenuVisible}
            isStandard={false}
          />
        ) : (
          <DotCommand
            isShow={isExpanded || props.isMenuVisible}
            isStandard={false}
          />
        )}
      </div>

      {menuLenght > 1 && (
        <div
          className="resultatRow"
          style={{
            visibility: isExpanded ? "visible" : "collapse",
            width: props.width,
            marginTop: "-2px",
          }}
        >
          <ul className="ulmenu">
            {props.currentData.map((item) => (
              <li
                className="limenu"
                key={item.id}
                onClick={() => handleClickItem(item)}
              >
               {!props.withoutIcon && <div
                  style={{
                    float: "left",
                  }}
                >
                  {getIcon(item)}
                </div>
                }
                {item.item}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
